"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
var _typeof = require("@babel/runtime/helpers/typeof");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
var _extends2 = _interopRequireDefault(require("@babel/runtime/helpers/extends"));
var _objectWithoutProperties2 = _interopRequireDefault(require("@babel/runtime/helpers/objectWithoutProperties"));
var _react = _interopRequireWildcard(require("react"));
var _isFunction = _interopRequireDefault(require("lodash/fp/isFunction"));
var _omit = _interopRequireDefault(require("lodash/fp/omit"));
var _validate = require("@active/core/email/validate");
var _Input = _interopRequireDefault(require("../Input"));
var _excluded = ["registerValidate"];
function _getRequireWildcardCache(e) { if ("function" != typeof WeakMap) return null; var r = new WeakMap(), t = new WeakMap(); return (_getRequireWildcardCache = function _getRequireWildcardCache(e) { return e ? t : r; })(e); }
function _interopRequireWildcard(e, r) { if (!r && e && e.__esModule) return e; if (null === e || "object" != _typeof(e) && "function" != typeof e) return { "default": e }; var t = _getRequireWildcardCache(r); if (t && t.has(e)) return t.get(e); var n = { __proto__: null }, a = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var u in e) if ("default" !== u && {}.hasOwnProperty.call(e, u)) { var i = a ? Object.getOwnPropertyDescriptor(e, u) : null; i && (i.get || i.set) ? Object.defineProperty(n, u, i) : n[u] = e[u]; } return n["default"] = e, t && t.set(e, n), n; }
var validate = function validate(value) {
  return value && !(0, _validate.isEmail)(value) ? 'react-ui.validation.invalid' : '';
};
var EmailInput = function EmailInput(_ref) {
  var registerValidate = _ref.registerValidate,
    rest = (0, _objectWithoutProperties2["default"])(_ref, _excluded);
  (0, _react.useEffect)(function () {
    if ((0, _isFunction["default"])(registerValidate)) {
      registerValidate(validate);
    }
  }, [registerValidate]);
  return /*#__PURE__*/_react["default"].createElement(_Input["default"], (0, _extends2["default"])({
    type: "email"
  }, (0, _omit["default"])(['onTouched'])(rest)));
};
var _default = exports["default"] = EmailInput;